import {FormControl, InputLabel, MenuItem, Select} from "@material-ui/core"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import React from "react"
import { Html5Entities } from 'html-entities'

const entities = new Html5Entities();

/**
 * A selector to specify a person's Bank.
 *
 * @param banks: {Object} Map containing all the values of the possible bank names.
 * @param bank: {String} The value of the selected bank.
 * @param label: {String} The text labeling (or giving a title to) the selector itself.
 * @param classes: {Object} Contains the JSS classes definitions for the selector.
 * @param changeBank: {Function} The event handler that is used to notify that a different bank has
 * been selected.
 */
const BankSelector = ({
                                  bank = "",
                                  banks,
                                  label = "Banco",
                                  classes = {},
                                  tabIndex = 5,
                                  changeBank = event => null
                              }) => (
    <FormControl className={classes.bankContainer}>
        <InputLabel htmlFor="bank">{label}</InputLabel>

        <Select
            onChange={changeBank}
            IconComponent={KeyboardArrowDown}
            value={bank}
            inputProps={{
                name: 'bank',
                id: 'bank',
                tabIndex
            }}>
            {makeBankItems(banks)}
        </Select>
    </FormControl>
)

function makeBankItems(banks) {
  return banks.sort((b1, b2) => b1.id - b2.id)
              .map(function(bank) {
                return <MenuItem value={bank.id} key={bank.id}>{entities.decode(bank.description)}</MenuItem>;
              })
}

export default BankSelector
